<a (click)="skipToMainContent()" href onclick="return false;" class="skip-link">
  {{ 'navigation.skipToMain' | finLocalization }}
</a>
